export default "__VITE_ASSET__Bmy$5kVL__"